const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

/*
ABCDEFGHIJKLMNOPQRSTUVWXYZ
--------------------------
01234567890123456789012345
0         1         2
*/

export function kanbanInsert(array, pos) {
  const insert = (pos, value) => array.toSpliced(pos, 0, value);
  
  // if there are no elements, the first element should be 'B'
  if (array.length === 0) {
    return ['B'];
  }
  
  // insert in the end with an extra letter:
  if (pos >= array.length) {
    // remove ending after "."
    const last = array[array.length - 1].split('.')[0];

    const letters = last.split('').reverse();

    const newLetters = [];

    let carry = true;

    for (let letter of letters) {
      if (carry) {
        if (letter !== 'Z') {
          newLetters.push(ALPHABET[letterAt(letter) + 1 ]);
          carry = false;
        }
        else {
          newLetters.push('B');
          carry = true;
        }
      }
      else {
        newLetters.push(letter);
      }
    }
    
    return [...array, newLetters.reverse().join('')];
  }

  else {
    let next = array[pos];
    let prev = array[pos - 1];

    // insert in the beginning
    if (!prev) {

      // if it's not 'B', (IE: DEE), insert "C"
      // if (next[0] !== 'B') {//   array.toSpliced(0, 0, prevLetter(next[0]));
      
      // if last letter is "B", then need to insert "A"
      if (lastLetter(next) === 'B') {
        return insert(0, removeLast(next) + (next.includes('.') ? 'AM' : 'A.M'));
      }

      else if (next[0] !== 'B' && next[0] !== 'A') {
        return insert(0, prevLetter(next[0]));
      }

      // substract one letter and add it to the end
      else {
        return insert(0, removeLast(next) + (prevLetter(lastLetter(next))  || ''));
      }
    }

    // insert in the middle of two items:
    else {
      next = next.replace('.', '');
      prev = prev.replace('.', '');

      const maxLength = Math.max(prev.length, next.length);

      for (let i = 0; i < maxLength; ++i) {
        if (next[i] !== prev[i]) {
          const diff = letterAt(next[i]) - letterAt(prev[i]);

          // gap is 'BB' -> 'BH', use the middle letter (E):
          if (diff > 1) { // } && next[i] && prev[i]) {
            let entry = prev.substring(0, i) + ALPHABET[letterAt(prev[i]) + Math.floor(diff / 2)];

            // if the last letter in the entry is "A", it's the last item. Add "M in the end"

            if (entry.charAt(entry.length - 1) === 'A') {
              entry += "M";
            }

            console.log('entry:', entry)
            return insert(pos, entry.length <= 6 ? entry : entry.slice(0, 6) + '.' + entry.slice(6));
          }

          // gap is only one character, IE: 'HBZ' -> 'HCA':
          //                                  ^        ^
          else {
            // [BZ, CAA] -> [BZ, BZM, CAA]
            if (prev[i+1] === 'Z' && next[i+1] === 'A') {
              return insert(pos, prev.substring(0, i+2) + 'M');
            }

            // compute difference of the i and i+1 characters:
            // [AY, BC] -> BA
            let prevValue = (ALPHABET.indexOf(prev[i] || 'A') * ALPHABET.length) + (prev[i+1] ? ALPHABET.indexOf(prev[i+1]) : 0);
            let nextValue = (ALPHABET.indexOf(next[i] || 'A') * ALPHABET.length) + (next[i+1] ? ALPHABET.indexOf(next[i+1]) : 0);

            console.log('ALPHABET.indexOf(prev[i] || 0):', ALPHABET.indexOf(prev[i] || 0))
            console.log('ALPHABET.indexOf(next[i] || 0):', ALPHABET.indexOf(next[i] || 0))

            let diff = prevValue + Math.floor((nextValue - prevValue) / 2);
            console.log('prev:', prev)
            console.log('next:', next)
            console.log('prev[i]:', prev[i])
            console.log('next[i]:', next[i])
            console.log('prev[i+1]:', prev[i+1])
            console.log('next[i+1]:', next[i+1])
            console.log('i:', i)
            console.log('diff:', diff)
            console.log('prevValue:', prevValue)
            console.log('nextValue:', nextValue)

            const entry = prev.substring(0, i) + ALPHABET[Math.floor(diff / ALPHABET.length)] + ALPHABET[diff % ALPHABET.length] + (diff === 0 ? 'M' : '');
            return insert(pos, entry.length <= 6 ? entry : entry.slice(0, 6) + '.' + entry.slice(6));
          }
        }
      }
    }
  }
}

function removeLast(string) {
  return string.substring(0, string.length - 1)
}

function lastLetter(string) {
  return string[string.length - 1];
}

function letterAt(char) {
  return ALPHABET.indexOf(char);
}

function prevLetter(char) {
  return ALPHABET[ALPHABET.indexOf(char) - 1];
}
